import React from 'react';
import { useConfiguration } from '../../context/configurationContext';
import loadable from '@loadable/component';
import css from './FooterContainer.module.css';
import { LinkedLogo } from '../../components';
import BlockBuilder from '../PageBuilder/BlockBuilder';

import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useHistory } from 'react-router-dom';

const MAX_MOBILE_SCREEN_WIDTH = 1024;
const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: (components) => components.SectionBuilder,
  }
);

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();
  const history = useHistory();
  // If footer asset is not set, let's not render Footer at all.
  if (Object.keys(footer).length === 0) {
    return null;
  }

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = {
    ...footer,
    sectionId: 'footer',
    sectionType: 'footer',
    linkLogoToExternalSite: topbar?.logoLink,
  };
  // return <SectionBuilder sections={[footerSection]} />;

  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;
  const logoLayout = isMobileLayout ? 'mobile' : 'desktop';
  const showSocialMediaLinks = footer?.socialMediaLinks?.length > 0;

  const linksWithBlockId = footer?.socialMediaLinks?.map((sml) => {
    return {
      ...sml,
      blockId: sml.link.platform,
    };
  });

  const linksColumns = [
    {
      title: 'SOFTWARE',
      links: [
        {
          label: 'VPC Creator',
          to: '/coming-soon',
        },
        {
          label: 'Arena4D',
          to: '/coming-soon',
        },
        {
          label: 'CAD Plugins',
          to: '/coming-soon',
        },
        {
          label: 'Zappcha App',
          to: '/coming-soon',
        },
        {
          label: 'Zappcha Cloud',
          to: '/coming-soon',
        },
        {
          label: 'Point Server',
          to: '/coming-soon',
        },
      ],
    },
    {
      title: 'SERVICES',
      links: [
        {
          label: 'About Us',
          to: '/about-us',
        },
        {
          label: 'Subscriptions',
          to: '/coming-soon',
        },
        {
          label: 'Services',
          to: '/coming-soon',
        },
        {
          label: 'Training',
          to: '/coming-soon',
        },
        {
          label: 'Interviews',
          to: '/coming-soon',
        },
      ],
    },
    {
      title: 'COMPANY',
      links: [
        {
          label: 'Blog',
          to: '/coming-soon',
        },
        {
          label: 'Privacy Policy',
          to: '/privacy-policy',
        },
        {
          label: 'Support',
          to: '/coming-soon',
        },
        {
          label: 'About Us',
          to: '/about-us',
        },
      ],
    },
  ];

  return (
    <div className={css.footerWrapper}>
      <div className={css.container}>
        <div className={css.contactBox}>
          <div className={css.contactBoxItem}>Mail: info@scan-wow.com</div>
          <div className={css.contactBoxItem}>Phone: +44 7542 137335</div>

          <div className={`${css.contactBoxItem} ${css.noBorderRight}`}>
            <a href="https://x.com/ScanWow">
              <XIcon className={css.socialIcon} />
            </a>
            <a href="https://www.instagram.com/scan_wow/">
              <InstagramIcon className={css.socialIcon} />
            </a>
            <a href="https://www.youtube.com/@ScanWow">
              <YouTubeIcon className={css.socialIcon} />
            </a>
            <a href="https://www.linkedin.com/company/scanwow/posts/?feedView=all&viewAsMember=true">
              <LinkedInIcon className={css.socialIcon} />
            </a>
          </div>
        </div>

        <div className={css.columns}>
          <div className={css.column}>
            <div className={css.columnHead}>Top Categories</div>

            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Buildings
            </div>

            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Characters
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Animals
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Cars
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Plants & Trees
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Gaussian Splat
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Point Cloud
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Voxel Assets
            </div>
            <div className={css.columnLink} onClick={() => history.push('/s')}>
              Mesh Assets
            </div>
          </div>

          <div className={css.column}>
            <div className={css.columnHead}>Our Site</div>
            <div className={css.columnLink} onClick={() => history.push('/signup')}>
              Sign up
            </div>
            <div className={css.columnLink} onClick={() => history.push('/about-us')}>
              About us
            </div>
            <div
              className={css.columnLink}
              onClick={() =>
                typeof window !== 'undefined' && (window.location.href = '/how-it-works')
              }
            >
              How it works
            </div>
            <div className={css.columnLink} onClick={() => history.push('/become-a-creator')}>
              Become a creator
            </div>
            <div className={css.columnLink} onClick={() => history.push('/sell-scans')}>
              Browse scans
            </div>
            <div className={css.columnLink} onClick={() => history.push('/sell-scans')}>
              Sell scans
            </div>

            <div
              className={css.columnLink}
              onClick={() => history.push('/sponsorship-partnership-opportunities')}
            >
              Sponsorship
            </div>
            <div className={css.columnLink} onClick={() => history.push('/coming-soon')}>
              Events
            </div>
            <div className={css.columnLink} onClick={() => history.push('/blog')}>
              Blog
            </div>
            <div className={css.columnLink} onClick={() => history.push('/contact')}>
              Contact
            </div>
          </div>

          <div className={css.wideColumn}>
            <div className={css.topColumnsWrapper}>
              <div className={css.column}>
                <div className={css.columnHead}>Legal Documents</div>
                <div className={css.columnLink} onClick={() => history.push('/privacy-policy')}>
                  Privacy policy
                </div>
                <div className={css.columnLink} onClick={() => history.push('/terms-of-service')}>
                  Terms of service
                </div>
                <div
                  className={css.columnLink}
                  onClick={() => history.push('/acceptable-use-policy')}
                >
                  Acceptable use policy
                </div>
              </div>
              <div className={css.column}>
                <div className={css.columnHead}>Support</div>
                <div className={css.columnLink} onClick={() => history.push('/knowledge-hub')}>
                  Knowledge hub
                </div>
                <div className={css.columnLink} onClick={() => history.push('/coming-soon')}>
                  Chat with support
                </div>
              </div>
            </div>

            <div className={css.requestBox}>
              <p className={css.requestBoxTitle}>Have a scanning challenge?</p>
              <p className={css.requestBoxDescription}>
                Post your request on ScanWow and let the community handle it!
              </p>
              <a className={css.requestBoxButton} href={'/coming-soon'}>
                <span>Create request</span>
              </a>
            </div>
          </div>
        </div>

        <div className={css.copywright}>©2025 • ScanWow</div>
      </div>
      {/* <div className={css.sectionLeft}>
        <LinkedLogo
          rootClassName={css.logoLink}
          logoClassName={css.logoWrapper}
          logoImageClassName={css.logoImage}
          linkToExternalSite={topbar?.logoLink}
          layout={logoLayout}
        />
        {showSocialMediaLinks ? (
          <div className={css.icons}>
            <BlockBuilder
              blocks={linksWithBlockId}
              sectionId={'footer'}
              options={footer?.options}
            />
          </div>
        ) : null}
      </div>
      <div className={css.sectionRight}>
        {linksColumns.map((c) => (
          <div className={css.column}>
            <p className={css.columnTitle}>{c.title}</p>
            {c.links.map((l) => (
              <a href={l.to} className={css.columnLink}>
                {l.label}
              </a>
            ))}
          </div>
        ))}
      </div> */}
    </div>
  );
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
